module.exports = __webpack_public_path__ + "static/media/dapIcon.a088e091.png";